import {Component, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-modal-non-returnable-items',
  templateUrl: './modal-non-returnable-items.component.html',
  styleUrls: ['./modal-non-returnable-items.component.scss']
})
export class ModalNonReturnableItemsComponent {
  @Output() agreeEvent: EventEmitter<any> = new EventEmitter();
  @Output() agreeNotShowMoreEvent: EventEmitter<boolean> = new EventEmitter();

  public isModalShow: boolean = false;
  public isDarkBackground: boolean = false;

  show() {
    this.isModalShow = true;
    this.isDarkBackground = true;
  }

  agree() {
    this.agreeEvent.emit();
    this.closeModal();
  }

  notAgree() {
    this.closeModal();
  }

  agreeNotShowMore() {
    this.closeModal();
    this.agreeNotShowMoreEvent.emit();
  }

  closeModal() {
    this.isModalShow = false
    this.isDarkBackground = false;
  }
}
